/**
 * 룰 추출 프롬프트(dose-review Phase 2) 프론트 상수 — spec 2026-09-30 D-6.
 *
 * 백엔드 `DOSE_EXTRACT_ALLOWED_MODELS`(dose-extract-prompt.constants.ts)의 프론트 사본이다.
 * 편집기 모델 칸 채움 폴백·안내 문구에 쓴다. 목록을 넓히는 변경은 백엔드와 이 사본을 함께 고친다.
 * 거절 사유 문구는 백엔드 한 곳(서버 message)뿐이다 — 프론트는 서버 message를 그대로 보인다.
 */

/** 룰 추출 프롬프트에 허용되는 모델(Bedrock 매핑 Claude 2종 — D-6). */
export const DOSE_EXTRACT_ALLOWED_MODELS = [
  "CLAUDE_SONNET_4_6",
  "CLAUDE_OPUS_4_6",
] as const;

/** 활성 조회 실패·활성 없음·허용 밖 모델일 때 편집기 모델 칸을 채우는 기본값(D-6). */
export const DEFAULT_DOSE_EXTRACT_MODEL = "CLAUDE_SONNET_4_6";

/** `dose_extract_*` 타입 판별 — PromptType 값/임의 문자열 모두 받는다. */
export const isDoseExtractPromptType = (type?: string | null): boolean =>
  typeof type === "string" && type.startsWith("dose_extract_");

/** 모델이 허용 목록에 있는지. */
export const isAllowedDoseExtractModel = (model?: string | null): boolean =>
  typeof model === "string" &&
  (DOSE_EXTRACT_ALLOWED_MODELS as readonly string[]).includes(model);
